import {
  Keyboard,
  KeyboardAvoidingView,
  Platform,
  Pressable,
  StatusBar,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";

import { registerEmail, sendEmail } from "../../../services/Auth/authService";
import TopIconView from "../components/TopIconView";
import AuthIcons from "../../../assets/Icons/AuthIcons";
import { styles } from "../auth.style";
import GlobalStyles from "../../../globalStyles/globalStyles";
import CustomComponent from "../../../components/CustomComponent";
import BottomView from "../../../components/GlobalComponents/BottomView";
import { Entypo } from '@expo/vector-icons';
import { Colors } from "../../../globalStyles/ColorConfig";

type SetPasswordAuthProps = {
  route: any;
  navigation: any;
};

const SetPasswordAuth = ({ route, navigation }: SetPasswordAuthProps) => {
  // const navigation = useNavigation();
  const { mail } = route.params;
  const [newpassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isNewPwdError, setIsNewPwdError] = useState(false);
  const [isConfirmPwdError, setIsConfirmPwdError] = useState(false);
  const [errorTitles, setErrorTitles] = useState<string[]>([]);

  const handleNewPasswordChange = (text: string) => {
    setIsNewPwdError(false)
    setErrorTitles([])
    setNewPassword(text);
  };

  const handleConfirmPasswordChange = (text: string) => {
    setIsConfirmPwdError(false)
    setErrorTitles([])
    setConfirmPassword(text);
  };

  const handleSumbitMail = async () => {
    setIsNewPwdError(false)
    setIsConfirmPwdError(false)
    const errors: string[] = [];

    if(!newpassword.length || !confirmPassword ){
      errors.push("Password fields are required!")
      setIsNewPwdError(true)
      setIsConfirmPwdError(true)
    }
    if (newpassword && newpassword.length < 4) {
      errors.push("Password should be at least 4 characters long!");
      setIsNewPwdError(true)
    }
    if (newpassword && confirmPassword !== newpassword) {
      errors.push("Both password should match!");
      setIsConfirmPwdError(true)
    }

    if(errors.length > 0) {
      // setIsPasswordError(true);
      setErrorTitles(errors);
      return;
    }

    const credentials = {
      email: mail,
      password: confirmPassword,
    };
    await registerEmail(credentials);
    const mailBody={
      userEmail: mail,
      messageBody: "Welcome to the Spark Family. We are excited to have you.🌟",
      messageSubject: " 🎉 Welcome to Spark: Your Account has been Created!"
    }
    await sendEmail(mailBody)
    navigation.navigate("auth-mobile", { mail });
  };

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="dark-content" backgroundColor={Colors.white000} />
        <Pressable style={{flex: 1}} onPress={Keyboard.dismiss}>
          <View style={styles.mobileAuthView}>
            <TopIconView icon={<AuthIcons.PasswordIcon />} password={true} />
            <CustomComponent.TextView
              title="Enter your password"
              textStyle={GlobalStyles.heading3}
            />
            <CustomComponent.TextView
              title="You need to enter password for"
              textStyle={GlobalStyles.bodyText}
            >
              <TouchableOpacity onPress={() => navigation.goBack()}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    top: 1,
                  }}
                >
                  <Text style={[styles.subText, styles.subHeader]}>{mail}</Text>
                  <AuthIcons.EditIcon />
                </View>
              </TouchableOpacity>
            </CustomComponent.TextView>
            <View
              style={{
                top: 10,
                gap: 10
              }}
            >
              <View style={{width: '100%', height: 60}}>
                <CustomComponent.InputField
                  placeholder="Enter new password"
                  keyboardtype="default"
                  onTextChange={handleNewPasswordChange}
                  password={true}
                  error={isNewPwdError}
                />
              </View>
              <View style={{width: '100%', height: 60}}>
                <CustomComponent.InputField
                  placeholder="Confirm new password"
                  keyboardtype="default"
                  onTextChange={handleConfirmPasswordChange}
                  password={true}
                  error={isConfirmPwdError}
                />
              </View>
              <View style={{marginTop: 10, gap: 10}}>
              {errorTitles.map((error, index) => (
                <View style={{flexDirection: 'row', alignItems: 'center', gap: 4}}> 
                  <Entypo name="circle-with-cross" size={24} color={Colors.red10} />
                  <CustomComponent.TextView
                  key={index}
                  title={error}
                  textStyle={[GlobalStyles.captionText, { color: "red" }]}
                />
                </View>
              ))}
              </View>
            </View>
          </View>
          <BottomView
            enableTitle={false}
            onPress={handleSumbitMail}
            disableBtn={true}
            style={{paddingBottom: 20}}
          />
        </Pressable>
    </SafeAreaView>
  );
};

export default SetPasswordAuth;
